define( [
	"../core",
	"../selector"
], function( jQuery ) {

"use strict";

jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/hiddenVisibleSelectors.js
// module id = 1297
// module chunks = 0